module.exports = __webpack_public_path__ + "static/po-impact-img-e4f1c4e877f319b5e0ec71793e74401f.png";